import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { CustomButton } from "../../../components/custom/custom-button.jsx";
import { useAppContext } from "../../../context/AppContext";
import { useQueryClient } from "@tanstack/react-query";
import helperService from "../../../services/helper.service.js";
import axiosInstance from "../../../services/api.service.js";
import LightLoader from "../../Loader/LightLoader/LightLoader.jsx";
import moment from "moment";

function DeletePayout({ payout, title, onClose }) {
	const queryClient = useQueryClient();
	const { showToastInfo, showToastError } = useAppContext();
	const [loading, setLoading] = useState(false);

	const submit = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.delete(
				`/api/v1/payout/${payout.id}`
			);
			showToastInfo(response?.data?.message || "Payout deleted successfully");
		} catch (error) {
			showToastError(error?.response?.data?.message || "An error occurred");
		} finally {
			queryClient.invalidateQueries(["all-payouts"]);
			setLoading(false);
			onClose();
		}
	};

	return (
		<div className="my-[5%] mx-0 w-[615px] h-auto rounded-[10px] bg-white p-[35px] shadow-[0px_2px_20px_0px_rgba(0, 0, 0, 0.15)]">
			<div className="relative flex justify-center items-center pb-[22px] border-b border-[#528dc2] mb-[35px]">
				<h1 className="text-[#002564] text-[20px] font-[700] leading-[20px]">
					{title}
				</h1>
				<IoClose
					className="absolute right-[-20px] top-[-20px] cursor-pointer w-[24px] h-[24px] text-[#002564] rounded-full transition-all duration-300 ease-in-out hover:rotate-[180deg] hover:bg-[#002564] hover:text-white hover:p-[5px]"
					onClick={onClose}
				/>
			</div>

			<p className="text-center mb-5 text-[#002564] text-[14px]">
				You are about to delete this payout
			</p>

			<div className="flex flex-col gap-4 text-[14px] text-[#1E1E1E]">
				<div>
					<strong>Client Name:</strong>
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">{payout?.clientName}</p>
				</div>
				<div>
					<strong>Amount:</strong>
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">
						{helperService.handleMoneyFormat(payout?.amount, 2, true, "NGN")}
					</p>
				</div>
				<div>
					<strong>Start Date:</strong>{" "}
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">
						{moment(payout?.dueDate).format("MMM DD, YYYY")}
					</p>
				</div>
				<div>
					<strong>Frequency:</strong>{" "}
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">
						{helperService.capitalize(payout?.frequency)}
					</p>
				</div>
				<div>
					<strong>Cycles:</strong>{" "}
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">{payout?.cycle}</p>
				</div>
				<div>
					<strong>Notify Teams:</strong>
					<p className="bg-[#f9f9f9] p-2 rounded mt-1 leading-[25px]">
						{payout?.notifyTeams?.join(", ")}
					</p>
				</div>
				<div>
					<strong>Additional Notes:</strong>
					<p className="bg-[#f9f9f9] p-2 rounded mt-1">
						{payout?.additionalNotes || "N/A"}
					</p>
				</div>
			</div>

			<div className="flex justify-center w-full mt-8">
				<CustomButton
					onClick={submit}
					className="!bg-[#FF2E31] !border-none !outline-none !w-full md:!w-[180px] !h-[40px]"
				>
					{loading ? <LightLoader /> : "Confirm Delete"}
				</CustomButton>
			</div>
		</div>
	);
}

export default DeletePayout;
